export default "__VITE_ASSET____NxjTrc__"